import { render, staticRenderFns } from "./FieldDropdown.vue?vue&type=template&id=afd4dca2&scoped=true"
import script from "./FieldDropdown.vue?vue&type=script&lang=js"
export * from "./FieldDropdown.vue?vue&type=script&lang=js"
import style0 from "./FieldDropdown.vue?vue&type=style&index=0&id=afd4dca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd4dca2",
  null
  
)

export default component.exports